import { Box, SxProps, Theme } from "@mui/material";
import useIsMobile from "components/hooks/useIsMobile";
import { ReactNode } from "react";

type FlexBoxDirection = "column" | "row" | "row-reverse" | "column-reverse";
type FlexBoxStyle = "contained" | "default";
type FlexBoxSize = "regular" | "large";

interface FlexBoxProps {
  children?: ReactNode;
  sx?: SxProps<Theme>;
  direction?: FlexBoxDirection;
  gap?: string;
  alignItems?: string;
  justifyContent?: string;
  style?: FlexBoxStyle;
  variant?: FlexBoxStyle;
  size?: FlexBoxSize;
  flex?: number;
  stackedMobile?: boolean;
}

export default ({
  children,
  sx,
  direction = "row",
  justifyContent = "start",
  alignItems,
  gap = "12px",
  variant = "default",
  size = "regular",
  flex = 1,
  stackedMobile,
}: FlexBoxProps) => {
  const isMobile = useIsMobile();
  const containedStyles =
    variant === "contained"
      ? {
          background: "white",
          padding: size == "large" && !isMobile ? "20px 24px" : "16px 20px",
          borderRadius: "12px",
          border: "1px solid #D4D4D4",
        }
      : {};
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: stackedMobile && isMobile ? "column" : direction,
        justifyContent: justifyContent,
        gap: gap,
        flex: flex,
        alignItems: alignItems
          ? alignItems
          : direction === "row" && !isMobile
            ? "center"
            : "start",
        "& > div": {
          ...(direction === "column" ? { width: "100%" } : {}),
        },
        ...containedStyles,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
